import React from 'react'
import { CopyOutlined } from '@ant-design/icons'
import { Button } from 'antd'

import { ItemList } from '~components'
import { PageLayout } from '~stories'

import styles from './Pricetemplates.module.css'

const getPriceTemplateCopyLink = id => <Button href={`/price_templates/${id}/copy`} icon={<CopyOutlined />} type='link'/>
const getPriceTemplateNameWithLink = ({ _id: id, name }) => <a href={`/price_templates/${id}/edit`}>{String(name).toUpperCase()}</a>

const columnData = [
  {
    render: ({
      _id: id
    }) => getPriceTemplateCopyLink(id),
    sorter: false,
    title: '',
    width: '5%'
  },
  {
    dataIndex: 'name',
    render: (text, priceTemplate) => getPriceTemplateNameWithLink(priceTemplate),
    sortDirections: ['descend', 'ascend', 'descend'],
    sorter: true,
    title: 'Name',
    width: '30%'
  },
  {
    dataIndex: 'description',
    title: 'Description',
    width: '60%'
  }
]

const createButton = <Button className={styles.actionContainer} href='/price_templates/dynamic/new' type='primary'>Create</Button>

const DynamicPriceTemplates = () => {
  return (
    <PageLayout extra={[createButton]} title='Dynamic Price Templates'>

      <div className={styles.pricetemplatesLayout}>
        <ItemList
          columns={columnData}
          defaultFilter={{ type: 'dynamic' }}
          resource='priceTemplates'
        />
      </div>
    </PageLayout>
  )
}

export default DynamicPriceTemplates
